import { Typography } from '@mui/material'
import React from 'react'

const ErrorMessage = ({ text }) => {
    return (
        <Typography fontFamily={"Satoshi-Light"} variant="caption" color="red">
            {text}
        </Typography>
    )
}

export default ErrorMessage